import * as React from "react";
const SvgFiRrTruckMedical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 5h-2c0-2.206-1.794-4-4-4H4C1.794 1 0 2.794 0 5v10c0 1.881 1.309 3.452 3.061 3.877A3.4 3.4 0 0 0 3 19.5C3 21.43 4.57 23 6.5 23s3.5-1.57 3.5-3.5c0-.169-.017-.335-.041-.5h4.082a3.5 3.5 0 0 0-.041.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5a3.4 3.4 0 0 0-.061-.623C22.691 18.452 24 16.881 24 15v-5c0-2.757-2.243-5-5-5m0 2c1.654 0 3 1.346 3 3v1h-5V7zM2 15V5c0-1.103.897-2 2-2h9c1.103 0 2 .897 2 2v12H4c-1.103 0-2-.897-2-2m18 2h-3v-4h5v2c0 1.103-.897 2-2 2M4 10a1 1 0 0 1 1-1h2.5V6.5a1 1 0 1 1 2 0V9H12a1 1 0 1 1 0 2H9.5v2.5a1 1 0 1 1-2 0V11H5a1 1 0 0 1-1-1"
    />
  </svg>
);
export default SvgFiRrTruckMedical;
